import { Box } from "@mui/material";
import React from "react";
import { TerminalTabContentType } from "store/atoms/terminalAtoms";

const TraceContent: React.FC<TerminalTabContentType> = ({ content }) => {
	return <Box sx={{ px: 2 }}>{content}</Box>;
};

export default React.memo(TraceContent);
